import { OrderApi } from '@/api'
import { configuration } from '@/lib/api'

export const orderApi = new OrderApi(configuration)
